import { useEffect } from 'react';
import {
  UserPreferences,
  useGetUserPreference,
} from '../api/hooks/preference.hooks';
import i18n from '.';

export const useSyncLanguage = () => {
  const languagePreference = useGetUserPreference<string>(
    UserPreferences.USER_LANGUAGE,
    {
      fetchPolicy: 'cache-only',
    }
  );

  useEffect(() => {
    const resetToSystemLanguage =
      languagePreference?.value === undefined ||
      languagePreference.value === 'system';
    i18n.changeLanguage(
      resetToSystemLanguage ? undefined : languagePreference.value
    );
  }, [languagePreference]);
};
